"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _playlistParser = require("../parsers/playlist/playlist-parser");

var _fetcher = _interopRequireDefault(require("../fetchers/fetcher"));

var _playlistFetcher = _interopRequireDefault(require("../fetchers/playlist-fetcher"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Playlist is the base type for all supported playlists
 */
var Playlist =
/*#__PURE__*/
function () {
  function Playlist(struct, body) {
    _classCallCheck(this, Playlist);

    this.body = body;
  }
  /**
   * @static parse - Parse a playlist body
   *
   * @param  {String} playlistBody The contents of a m3u8 playlist
   * @param  {Integer} startIdx Optional.  Will be the first integer used for MediaSegment ids
   * @return {Playlist}            Returns either a MediaPlaylist or a MasterPlaylist object
   */


  _createClass(Playlist, [{
    key: "basePath",
    set: function set(val) {
      this._basePath = val;
    },
    get: function get() {
      return this._basePath;
    }
  }], [{
    key: "parse",
    value: function parse(playlistBody, startIdx) {
      var idx = startIdx || 0;
      return _playlistParser.PlaylistParser.parse(playlistBody, idx);
    }
    /**
     * @static fetch - Fetch and parse a playlist from a URL
     *
     * @param  {String} playlistURL String to a URL that hosts a m3u8 playlist
     * @param  {Integer} startIdx Optional.  Will be the first integer used for MediaSegment ids
     * @return {Promise<Playlist>}  Returns a Promise with a
     */

  }, {
    key: "fetch",
    value: function fetch(playlistURL, startIdx) {
      var params = {
        url: playlistURL,
        startIdx: startIdx || 0
      };
      return new _playlistFetcher.default(params).fetch();
    }
  }]);

  return Playlist;
}();

var _default = Playlist;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/playlists/base-playlist.js
// module id = 125
// module chunks = 0